import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { S as SelectOption } from '../../../SelectList/SelectOption/SelectOption-BMRthYTo.js';

class SplitButtonItem extends PureComponent {
  render() {
    const {
      onClick,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(SelectOption, _extends({
      onClick: onClick
    }, rest));
  }
}
_defineProperty(SplitButtonItem, "propTypes", {
  onClick: PT.func.isRequired,
  value: PT.oneOfType([PT.string, PT.object]).isRequired
});

export { SplitButtonItem as S };
//# sourceMappingURL=SplitButtonItem-B9eSqC3-.js.map
